import { TFunction } from "i18next";
import styles from "./styles.module.css";
import { isRTL } from 'src/utils/global';
import {
    FaTools,      // لقطع الغيار
    FaFilter,     // للفلاتر
    FaTruck,      // للشاحنات
    FaCogs,       // للمعدات والآلات
    FaIndustry,
    FaHeadset,    // للدعم الفني
    FaShippingFast // للتوصيل
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Element } from "react-scroll";


const getServices = (t: TFunction) => (
    [
        {
            icon: <FaFilter />,
            title: t("services.inspection.filters_oil.title"),
            description: t("services.inspection.filters_oil.description"),
        },
        {
            icon: <FaTools />,
            title: t("services.inspection.filters_air.title"),
            description: t("services.inspection.filters_air.description"),
        },
        {
            icon: <FaTruck />,
            title: t("services.inspection.truck_parts.title"),
            description: t("services.inspection.truck_parts.description"),
        },
        {
            icon: <FaCogs />,
            title: t("services.inspection.heavy_machinery.title"),
            description: t("services.inspection.heavy_machinery.description"),
        },
        {
            icon: <FaIndustry />,
            title: t("services.inspection.industrial_parts.title"),
            description: t("services.inspection.industrial_parts.description"),
        },
        {
            icon: <FaHeadset />,
            title: t("services.inspection.tech_support.title"),
            description: t("services.inspection.tech_support.description"),
        },
        {
            icon: <FaShippingFast />,
            title: t("services.inspection.delivery_service.title"),
            description: t("services.inspection.delivery_service.description"),
        },
    ]
);

const ServicesInspection = () => {
    const { t } = useTranslation("home");

    return (
        <Element name="services" className={`${styles.services} ${isRTL() && styles.rtl}`}>
            <div className="container">
                {/* Title */}
                <h2 className={styles.title}>
                    {t("services.inspection.title", "تخصصاتنا ومنتجاتنا")}
                </h2>

                {/* Cards */}
                <div className="row g-4">
                    {getServices(t).map((service, index) => (
                        <div
                            data-aos="fade-up"
                            data-aos-delay={index}
                            data-aos-anchor-placement="top-bottom"
                            key={index}
                            className="col-12 col-md-6 col-lg-4 mx-auto" // تم إضافة col-lg-4 لجعل التصميم أفضل في الشاشات الكبيرة (3 كروت في الصف)
                        >
                            <div className={styles.card}>
                                <div className={styles.icon}>{service.icon}</div>
                                <h3 className={styles.cardTitle}>{service.title}</h3>
                                <p className={styles.description}>
                                    {service.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Element>
    );
};

export default ServicesInspection;